module.exports = __webpack_public_path__ + "img/cognitive-icon-dark.06166950.svg";